import { render, staticRenderFns } from "./left2.vue?vue&type=template&id=4e281f3b&scoped=true&"
import script from "./left2.vue?vue&type=script&lang=js&"
export * from "./left2.vue?vue&type=script&lang=js&"
import style0 from "./left2.vue?vue&type=style&index=0&id=4e281f3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e281f3b",
  null
  
)

export default component.exports